import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  Typography
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import Logo from 'src/components/Logo';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'src/store/actions/AuthActions';
import { useSelector } from 'react-redux';
import LassraLogo from 'src/components/LassraLogo';

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  }
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const [notifications] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector(state => state.Auth.companyProfile);

  const handleLogout = async () => {
    const response = await dispatch(logoutUser());
    if (response) {
      // navigate('/login', { replace: true });
      window.location.pathname = '/login';
    }
  };
  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar style={{ background: '#202340' }}>
        <RouterLink to="/">
          {/* <Logo /> */}
          <LassraLogo />
        </RouterLink>
        <Box flexGrow={1} />
        <Hidden mdDown>
          <Typography color="inherit" gutterBottom variant="h6">
            {profile?.fullname}
          </Typography>
          <IconButton color="inherit" onClick={handleLogout}>
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
          <IconButton color="inherit">
            <InputIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
